/**
 * Require Controllers
 * If any controller needs to be disabled, this is the place to do it
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */
var flsControllers = angular.module('flsControllers', []);

require('./controllers/AddressController');
require('./controllers/AvItemsController');
require('./controllers/BackgroundCheckController');
require('./controllers/CatererController');
require('./controllers/CertificationController');
require('./controllers/HcpController');
require('./controllers/NoteController');
require('./controllers/ProgramController');
require('./controllers/TemplateController');
require('./controllers/VenueController');
require('./controllers/AddressController');
require('./controllers/FieldController');
require('./controllers/ProfileController');
require('./controllers/BudgetController');
